import { render } from "./TheHeaderNaviForSpLayout.vue?vue&type=template&id=b23d7516&scoped=true&ts=true"
import script from "./TheHeaderNaviForSpLayout.vue?vue&type=script&lang=ts"
export * from "./TheHeaderNaviForSpLayout.vue?vue&type=script&lang=ts"

import "./TheHeaderNaviForSpLayout.vue?vue&type=style&index=0&id=b23d7516&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b23d7516"]])

export default __exports__